import { Injectable } from '@angular/core';
import {throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {SOURCE_TYPE} from "../constants/Tpiq.constants";

export function templatesUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/strategy-templates`;
}


@Injectable({
  providedIn: 'root'
})
export class TemplatesService extends TaxplanIQServices{


  constructor(http: HttpClient) {
    super(http);
  }

  getTemplatesList(org, user){
    const url = templatesUrl(org, user);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deleteTemplate(org, user, templateId){
    let url = templatesUrl(org, user);
    url += `/${templateId}`;
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createTemplate(org, user, data){
    const url = templatesUrl(org, user);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTemplate(org, user, templateId){
    let url = templatesUrl(org, user);
    url += `/${templateId}`;
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateTemplate(org, user, data){
    let url = templatesUrl(org, user);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  applyTemplate(org, user, data, planId){
    let url = templatesUrl(org, user);
    url += `/apply?planId=${planId}`;
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  publishTemplate(org, user, templateId){
    let url = templatesUrl(org, user);
    url += `/${templateId}/publish`;
    return this.create(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): any {
    return throwError(error.error);
  }
}
